import { default as _91slug_93msfiAekumQMeta } from "/app/pages/[slug].vue?macro=true";
import { default as reasonLQjTOSwkeLMeta } from "/app/pages/account/cancel/reason.vue?macro=true";
import { default as specialdUX57ED67eMeta } from "/app/pages/account/cancel/special.vue?macro=true";
import { default as change_45passwordlnF89pKfG4Meta } from "/app/pages/account/change-password.vue?macro=true";
import { default as change_45planEDEqjIrmJpMeta } from "/app/pages/account/change-plan.vue?macro=true";
import { default as indexQWKFaMHH2OMeta } from "/app/pages/account/index.vue?macro=true";
import { default as _91slug_93csqqTGxdlIMeta } from "/app/pages/authors/[slug].vue?macro=true";
import { default as _91slug_93rJNArKbvxWMeta } from "/app/pages/collections/[slug].vue?macro=true";
import { default as forgot_45password1UbT4qDpFeMeta } from "/app/pages/forgot-password.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as loginhHM0vSTW5jMeta } from "/app/pages/login.vue?macro=true";
import { default as my_45listb2xkgwPgmFMeta } from "/app/pages/my-list.vue?macro=true";
import { default as _91slug_93h6ecm9GkHAMeta } from "/app/pages/news/[slug].vue?macro=true";
import { default as indexoxV4GRc61hMeta } from "/app/pages/news/index.vue?macro=true";
import { default as notifications883AI3QFtaMeta } from "/app/pages/notifications.vue?macro=true";
import { default as on_45demand1KpQxitm92Meta } from "/app/pages/on-demand.vue?macro=true";
import { default as optionsulAcSo8ADLMeta } from "/app/pages/options.vue?macro=true";
import { default as indexakWThtjDyuMeta } from "/app/pages/ott/index.vue?macro=true";
import { default as complete0cZdC16J3TMeta } from "/app/pages/ott/login/complete.vue?macro=true";
import { default as indexEGSX0zVbxwMeta } from "/app/pages/ott/login/index.vue?macro=true";
import { default as completedA7kfZ6kLDMeta } from "/app/pages/ott/register/complete.vue?macro=true";
import { default as indexPgsjVUQA2eMeta } from "/app/pages/ott/register/index.vue?macro=true";
import { default as privacy_45policyOPxqa3IsSYMeta } from "/app/pages/privacy-policy.vue?macro=true";
import { default as checkoutB1VFKfYvaXMeta } from "/app/pages/register/checkout.vue?macro=true";
import { default as completeCvvx8y1Z6qMeta } from "/app/pages/register/complete.vue?macro=true";
import { default as indexhOBcdtdQ4pMeta } from "/app/pages/register/index.vue?macro=true";
import { default as onboardingSMCNy8jA8nMeta } from "/app/pages/register/onboarding.vue?macro=true";
import { default as select_45planT0fnx2QLURMeta } from "/app/pages/register/select-plan.vue?macro=true";
import { default as verify_45email5Srj1bBGqCMeta } from "/app/pages/register/verify-email.vue?macro=true";
import { default as reset_45password52TOS9kgCUMeta } from "/app/pages/reset-password.vue?macro=true";
import { default as rulesCVy0F1SzKVMeta } from "/app/pages/rules.vue?macro=true";
import { default as scheduleRBheWBi7r1Meta } from "/app/pages/schedule.vue?macro=true";
import { default as searchfcnTL5fl5XMeta } from "/app/pages/search.vue?macro=true";
import { default as terms_45of_45useA3Owpnmw23Meta } from "/app/pages/terms-of-use.vue?macro=true";
import { default as trainingTxoRaaPNwEMeta } from "/app/pages/training.vue?macro=true";
import { default as _91slug_93dlDiHX7ZBYMeta } from "/app/pages/videos/[slug].vue?macro=true";
import { default as _91slug_934NvLD3gMEiMeta } from "~/pages/news/[slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug()",
    component: () => import("/app/pages/[slug].vue")
  },
  {
    name: "account-cancel-reason",
    path: "/account/cancel/reason",
    component: () => import("/app/pages/account/cancel/reason.vue")
  },
  {
    name: "account-cancel-special",
    path: "/account/cancel/special",
    component: () => import("/app/pages/account/cancel/special.vue")
  },
  {
    name: "account-change-password",
    path: "/account/change-password",
    component: () => import("/app/pages/account/change-password.vue")
  },
  {
    name: "account-change-plan",
    path: "/account/change-plan",
    component: () => import("/app/pages/account/change-plan.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: indexQWKFaMHH2OMeta || {},
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "authors-slug",
    path: "/authors/:slug()",
    component: () => import("/app/pages/authors/[slug].vue")
  },
  {
    name: "collections-slug",
    path: "/collections/:slug()",
    component: () => import("/app/pages/collections/[slug].vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "pokerGO::page:login-page",
    path: "/login",
    meta: loginhHM0vSTW5jMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "my-list",
    path: "/my-list",
    component: () => import("/app/pages/my-list.vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    meta: _91slug_93h6ecm9GkHAMeta || {},
    component: () => import("/app/pages/news/[slug].vue")
  },
  {
    name: "news",
    path: "/news",
    meta: indexoxV4GRc61hMeta || {},
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notifications883AI3QFtaMeta || {},
    component: () => import("/app/pages/notifications.vue")
  },
  {
    name: "on-demand",
    path: "/on-demand",
    component: () => import("/app/pages/on-demand.vue")
  },
  {
    name: "mobile-menu",
    path: "/options",
    meta: optionsulAcSo8ADLMeta || {},
    component: () => import("/app/pages/options.vue")
  },
  {
    name: "ott",
    path: "/ott",
    component: () => import("/app/pages/ott/index.vue")
  },
  {
    name: "ott-login-complete",
    path: "/ott/login/complete",
    component: () => import("/app/pages/ott/login/complete.vue")
  },
  {
    name: "ott-login",
    path: "/ott/login",
    component: () => import("/app/pages/ott/login/index.vue")
  },
  {
    name: "ott-register-complete",
    path: "/ott/register/complete",
    component: () => import("/app/pages/ott/register/complete.vue")
  },
  {
    name: "ott-register",
    path: "/ott/register",
    component: () => import("/app/pages/ott/register/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/app/pages/privacy-policy.vue")
  },
  {
    name: "register-checkout",
    path: "/register/checkout",
    meta: checkoutB1VFKfYvaXMeta || {},
    component: () => import("/app/pages/register/checkout.vue")
  },
  {
    name: "register-complete",
    path: "/register/complete",
    meta: completeCvvx8y1Z6qMeta || {},
    component: () => import("/app/pages/register/complete.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: indexhOBcdtdQ4pMeta || {},
    component: () => import("/app/pages/register/index.vue")
  },
  {
    name: "register-onboarding",
    path: "/register/onboarding",
    component: () => import("/app/pages/register/onboarding.vue")
  },
  {
    name: "register-select-plan",
    path: "/register/select-plan",
    component: () => import("/app/pages/register/select-plan.vue")
  },
  {
    name: "register-verify-email",
    path: "/register/verify-email",
    meta: verify_45email5Srj1bBGqCMeta || {},
    component: () => import("/app/pages/register/verify-email.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("/app/pages/reset-password.vue")
  },
  {
    name: "rules",
    path: "/rules",
    component: () => import("/app/pages/rules.vue")
  },
  {
    name: "schedule",
    path: "/schedule",
    component: () => import("/app/pages/schedule.vue")
  },
  {
    name: "pokerGO::page:search-results-page",
    path: "/search",
    meta: searchfcnTL5fl5XMeta || {},
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "terms-of-use",
    path: "/terms-of-use",
    component: () => import("/app/pages/terms-of-use.vue")
  },
  {
    name: "training",
    path: "/training",
    meta: trainingTxoRaaPNwEMeta || {},
    component: () => import("/app/pages/training.vue")
  },
  {
    name: "videos-slug",
    path: "/videos/:slug()",
    component: () => import("/app/pages/videos/[slug].vue")
  },
  {
    name: "articlePreview",
    path: "/news/preview/:slug",
    meta: _91slug_934NvLD3gMEiMeta || {},
    component: () => import("~/pages/news/[slug].vue")
  }
]